import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-information-verification",
  "use": "icon-information-verification-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-information-verification\"><defs><style type=\"text/css\"></style></defs><path d=\"M512 64.7C264.9 64.7 64.7 264.9 64.7 512S264.9 959.3 512 959.3c247.1 0 447.3-200.3 447.3-447.3S759.1 64.7 512 64.7z m64 699.6c0 35.1-28.8 63.9-63.9 63.9s-63.9-28.8-63.9-63.9V508.7c0-35.1 28.8-63.9 63.9-63.9s63.9 28.8 63.9 63.9v255.6z m-63.9-440.8c-35.3 0-63.9-28.6-63.9-63.9s28.6-63.9 63.9-63.9 63.9 28.6 63.9 63.9-28.6 63.9-63.9 63.9z\" p-id=\"8775\" fill=\"#ffffff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/information-verification.svg
// module id = irkD
// module chunks = 102